export default __webpack_public_path__ + "static/media/slider-info-laptop-dark-top.b8383a84.svg";